import React, { useEffect } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';

function Dashboard() {
  const location = useLocation();
  const subscribed = new URLSearchParams(location.search).get('subscribed');

  useEffect(() => {
    if (subscribed === 'true') {
      // Update local user plan to pro
      try {
        const userData = localStorage.getItem('knowfi_user');
        if (userData) {
          const user = JSON.parse(userData);
          user.plan = 'pro';
          localStorage.setItem('knowfi_user', JSON.stringify(user));
        }
      } catch (e) {}
      // Redirect to home with success flag
      window.location.href = '/?welcome=pro';
    }
  }, [subscribed]);

  if (!subscribed) return <Navigate to="/" replace />;
  // eslint-disable-next-line no-unreachable
  return (
    <div style={styles.container}>
      <div style={styles.glowOrb} />

      <div style={styles.header}>
        <h1 style={styles.title}>Welcome to KnowFi 👋</h1>
        <p style={styles.subtitle}>Your financial education hub. What do you want to learn today?</p>
      </div>

      {/* Main tools */}
      <div style={styles.grid}>
        {cards.map((c, i) => (
          <Link to={c.link} key={i} style={{ ...styles.card, ...(c.featured ? styles.cardFeatured : {}) }}>
            <div style={styles.cardIcon}>{c.icon}</div>
            <h3 style={styles.cardTitle}>{c.title}</h3>
            <p style={styles.cardDesc}>{c.desc}</p>
            <span style={styles.cardCta}>{c.cta} →</span>
          </Link>
        ))}
      </div>

      {/* Quick tip */}
      <div style={styles.tip}>
        <span style={styles.tipIcon}>💡</span>
        <div>
          <strong>Pro tip:</strong> Start with the AI Finance Coach — just ask it anything. No question is too basic.
        </div>
      </div>
    </div>
  );
}

const cards = [
  {
    icon: '🤖',
    title: 'Ask the AI',
    desc: 'Get plain English answers to any finance question. No judgment, no jargon.',
    cta: 'Ask now',
    link: '/ask',
    featured: true,
  },
  {
    icon: '📖',
    title: 'Jargon Translator',
    desc: 'Paste any confusing financial term and get it explained like a smart friend would.',
    cta: 'Translate',
    link: '/ask',
  },
  {
    icon: '📊',
    title: 'Calculators',
    desc: 'Retirement planner, debt payoff calculator, and more. See your numbers.',
    cta: 'Calculate',
    link: '/calculators',
  },
  {
    icon: '🎓',
    title: 'Courses',
    desc: 'Bite-sized lessons on investing, saving, 401k, Roth IRA, and more.',
    cta: 'Coming soon',
    link: '/dashboard',
  },
];

const styles = {
  container: {
    background: '#0f172a',
    color: '#f8fafc',
    minHeight: '100vh',
    padding: '60px 40px',
    maxWidth: '1000px',
    margin: '0 auto',
    position: 'relative',
    overflow: 'hidden',
  },
  glowOrb: {
    position: 'absolute',
    top: '-80px',
    right: '-100px',
    width: '500px',
    height: '500px',
    background: 'radial-gradient(ellipse at center, rgba(56, 189, 248, 0.08) 0%, transparent 65%)',
    pointerEvents: 'none',
    zIndex: 0,
  },
  header: {
    position: 'relative',
    zIndex: 1,
    marginBottom: '48px',
  },
  title: {
    fontSize: '40px',
    fontWeight: '800',
    marginBottom: '8px',
    letterSpacing: '-0.5px',
  },
  subtitle: {
    color: '#64748b',
    fontSize: '16px',
    margin: 0,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '16px',
    position: 'relative',
    zIndex: 1,
    marginBottom: '32px',
  },
  card: {
    background: '#1e293b',
    borderRadius: '16px',
    padding: '28px',
    border: '1px solid #334155',
    textDecoration: 'none',
    color: '#f8fafc',
    display: 'block',
    transition: 'border-color 0.2s, transform 0.2s',
  },
  cardFeatured: {
    border: '1px solid rgba(56, 189, 248, 0.3)',
    background: 'linear-gradient(135deg, #1e293b 0%, rgba(56, 189, 248, 0.05) 100%)',
  },
  cardIcon: {
    fontSize: '36px',
    marginBottom: '14px',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '8px',
    margin: '0 0 8px',
  },
  cardDesc: {
    color: '#64748b',
    fontSize: '14px',
    lineHeight: 1.6,
    margin: '0 0 16px',
  },
  cardCta: {
    color: '#38bdf8',
    fontSize: '13px',
    fontWeight: '600',
  },
  tip: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    background: 'rgba(56, 189, 248, 0.06)',
    border: '1px solid rgba(56, 189, 248, 0.15)',
    borderRadius: '12px',
    padding: '16px 20px',
    fontSize: '14px',
    color: '#94a3b8',
    position: 'relative',
    zIndex: 1,
  },
  tipIcon: {
    fontSize: '18px',
    flexShrink: 0,
  },
};

export default Dashboard;
